import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderService } from '../tools/header.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IxellAPIService, Roles, LoginData } from '../tools/api.service';
import { Utils } from '../tools/utils';
import { StorageService } from '../tools/storage.service';
import { LogInService } from '../tools/login-service';
import { GoogleAnalyticsService } from '../tools/google-analytics';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit, OnDestroy {
    window = window;
    documentElement = document.documentElement;
    Math = Math;

    Utils = Utils;
    role: Roles = Roles.Unknown;
    path: string;
    urlPortailTuto: string = "";
    cart: any[] = [];
    coAdmin: boolean = false;
    login: string;
    password: string;
    displayFileImportantInformation: boolean = true;
    //dataUrlInfoImportante: string = "../../assets/InformationImportante/reformulationNoteClients_fr.pdf";
    //displayValidImportantInformation: boolean = false;
    language: string = "fr";
    currentLanguage: string;
    token: string;
    isSitePilote: boolean = false;

    private roleSub: any;
    private tutoSub: any;
    //checkRoleForGASub: any;
    private PaymentCheckSub: any;
    private autoConnexionLogInSub: any;
    private importantInformation: any;
    private sitePiloteSub: any;

    urlColorWebOnline: string = environment.colorWebOnlineRoot;
    urlColorCloud: string = environment.colorCloudRoot;

    constructor(private headerService: HeaderService, private router: Router, private apiService: IxellAPIService, private route: ActivatedRoute, private gaService: GoogleAnalyticsService, private logInService: LogInService, private storage: StorageService) { }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    ngOnInit() {

        this.initLanguage();

        this.login = this.route.snapshot.paramMap.get('login');
        if (!this.login) this.login = this.route.snapshot.queryParams['login'];
        if (this.login && this.login != "paymentAccepted") {
            this.password = this.route.snapshot.paramMap.get('pwd');
            if (!this.password) this.password = this.route.snapshot.queryParams['pwd'];
            if (this.password) {
                let data: LoginData = new LoginData();
                data.login = this.login;
                data.password = this.password;
                this.autoConnexionLogInSub = this.apiService.logInAutoConnexion(data).subscribe(async data => {
                    this.logInService.parseLogIn(data);
                    await this.delay(50);
                    // this.initHome();
                    //redirige vers la page home pour clear url et initHome commme si on venez d'utiliser la page de connexion normal
                    this.router.navigate(["home"]);
                });
            }
        }
        else {
            this.initHome();
        }
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     * 
     * @param ms
     */
    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    initHome() {


        //en cas de deconnexion 'actualLanguage' n'est pas réinitialisé
        this.currentLanguage = this.storage.get("actualLanguage");
        if (this.currentLanguage)
            this.headerService.changeLangue(this.currentLanguage);
        else {

            this.currentLanguage = navigator.language.split('-')[0];
            this.storage.set("actualLanguage", this.currentLanguage);
            this.headerService.changeLangue(this.currentLanguage);

            /* // Si la langue du navigateur est FR, met en fr sinon par défaut met en anglais
            if (this.currentLanguage == "fr") {
              this.storage.set("actualLanguage", "fr");
            this.headerService.changeLangue(this.currentLanguage);
            } else {
              this.translate.setDefaultLang('en');
              this.storage.set("actualLanguage", "en");
            }*/
        }


        /* désactivation redirection automatique vers "adminlacourlicence" */
        //if (this.storage.get("token")) {
        //    // Si déjà connecté, emmène à Home
        //    let role = this.storage.get("role");
        //    if (Number.parseInt(role) & Roles.AdminLacour) {
        //        this.router.navigate(['/adminlacourLicence']);
        //    }
        //}

        localStorage.removeItem("cart");
        let storedCart = JSON.parse(localStorage.getItem("cart"));
        this.headerService.changeNbProduct(0);
        this.headerService.changeProducts(JSON.stringify(storedCart));



        /* affichage home après connexion */
        Utils.deleteStorageData();
        this.headerService.changeCanBack(false);
        this.headerService.changeTitle("IxellWebLab");
        this.headerService.changeLogo(null);
        this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);
        this.headerService.verifyRole();
        if (Utils.isAttum(this.role)) {
            let code: string;
            this.tutoSub = this.apiService.getUrlPortailTuto(code).subscribe(data => {
                this.urlPortailTuto = data;
                if (this.tutoSub != null) this.tutoSub.unsubscribe();
            }, eror => {
                if (this.tutoSub != null) this.tutoSub.unsubscribe();
            });
        }
        let acceptedPayment = this.route.snapshot.paramMap.get('paymentAccepted');
        if (!acceptedPayment) {
            acceptedPayment = this.route.snapshot.paramMap.get('login');
        }
        let billingID = this.route.snapshot.paramMap.get('billingID');
        if (!billingID) {
            billingID = this.route.snapshot.paramMap.get('pwd');
        }
        if (acceptedPayment) {
            let paymentDone = false
            this.PaymentCheckSub = this.apiService.checkPayment(billingID).subscribe(data => {
                paymentDone = data;
                if (paymentDone) {
                    localStorage.removeItem("cart");
                    this.headerService.changeNbProduct(0);
                    this.headerService.changeProducts(null);

                    this.router.navigate(["home"]);
                }
                else {
                    this.router.navigate(["panier"]);
                }
                if (this.PaymentCheckSub != null) this.PaymentCheckSub.unsubscribe();
            }, error => {
                if (this.PaymentCheckSub != null) this.PaymentCheckSub.unsubscribe();
            });
        }
        if (Utils.isUserIxell(this.role) || Utils.isCTC(this.role))
            this.path = "/contretypage/request";
        else if (Utils.isAxalta(this.role))
            this.path = "/contretypage/historic";

        this.SitePilote();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    generate() {
        this.apiService.generateActivationCode().subscribe();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    ngOnDestroy() {
        if (this.PaymentCheckSub != null) this.PaymentCheckSub.unsubscribe();
        if (this.sitePiloteSub != null) this.sitePiloteSub.unsubscribe();
        if (this.roleSub != null) this.roleSub.unsubscribe();
        if (this.tutoSub != null) this.tutoSub.unsubscribe();
        if (this.autoConnexionLogInSub != null) this.autoConnexionLogInSub.unsubscribe();
        if (this.importantInformation != null) this.importantInformation.unsubscribe();
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    launchColorwebtech() {
        this.headerService.changeTitle("ColorWebtech");
        this.headerService.changeCanBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    launchColorwebtechEquinox() {
        this.headerService.changeTitle("Equinox");
        this.headerService.changeCanBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    launchColorbook() {
        this.headerService.changeTitle("Colorbook");
        this.headerService.changeCanBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    launchSupport() {
        this.headerService.changeTitle("support.supportAssistance");
        this.headerService.changeCanBack(true);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    launchAdminLacour() {
        this.headerService.changeTitle("Admin");
        this.headerService.changeCanBack(false);
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    launchContretypage() {
        this.headerService.changeTitle("Contretypage");
        this.headerService.changeCanBack(true);
        if (Utils.isUserIxell(this.role) || Utils.isCTC(this.role))
            this.path = "/contretypage/request";
        else if (Utils.isAxalta(this.role))
            this.path = "/contretypage/historic";
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    launchImportantInformation() {
      let modal = document.getElementById("ModalImportantInformation");
      modal.style.display = "block";

      //const byteCharacters = atob(data.doc);
      /////*----------------------------------------------------------------------------------------------------*/console.log("byteCharacters: ", byteCharacters);
      //const byteNumbers = new Array(byteCharacters.length);
      //for (let i = 0; i < byteCharacters.length; i++) {
      //  byteNumbers[i] = byteCharacters.charCodeAt(i);
      //}

      /////*----------------------------------------------------------------------------------------------------*/console.log("byteNumbers: ", byteNumbers);

      //const byteArray = new Uint8Array(byteNumbers);
      /////*----------------------------------------------------------------------------------------------------*/console.log("byteArray: ", byteArray);
      //var file = new Blob([byteArray], { type: 'application/pdf' });
      /////*----------------------------------------------------------------------------------------------------*/console.log("file: ", file);
      //this.dataLocalUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(file));

    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
     *
     * */
    closeImportantInformation() {
        let modal = document.getElementById("ModalImportantInformation");
        modal.style.display = "none";
        this.importantInformation = this.apiService.setCheckDocumentUserConnected(true).subscribe(data => {
            if (this.importantInformation != null) this.importantInformation.unsubscribe();
        }, eror => {
            if (this.importantInformation != null) this.importantInformation.unsubscribe();
        });
    }

    /* ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- ---------- */
    /**
      *
      * */
    private initLanguage() {
        ///*----------------------------------------------------------------------------------------------------*/console.log("function: initLanguage");
        ///*----------------------------------------------------------------------------------------------------*/console.log("this.headerService.currentLangue.subscribe");
        this.headerService.currentLangue.subscribe(event => {
            //console.log(event);
            //this.singleEvent$ = new BehaviorSubject(event);
            this.language = event;
            //let tmpLangue = "fr";
            //if (event != "fr") {
            //  tmpLangue = "en";
            //}
            //this.dataUrlInfoImportante = "../../assets/InformationImportante/reformulationNoteClients_" + tmpLangue + ".pdf";

            //console.log(this.dataUrlInfoImportante);

            //if (this.languageIsInit) {
            //  this.SelectDocument();
            //} else {
            //  this.languageIsInit = true;
            //}
        });
    }

    SitePilote() {
        //console.log(this.storage.get("CU"));
        this.sitePiloteSub = this.apiService.getListSitePilote().subscribe(data => {
            //console.log(data);
            if (this.storage.get("CU") && data.findIndex(x => x == this.storage.get("CU")) > -1) {
                this.isSitePilote = true;
            } else {
                this.isSitePilote = false;
            }
        }, error => {
            if (this.sitePiloteSub != null) this.sitePiloteSub.unsubscribe();
        });
    }

}
